import { api as axiosApi } from '../../utils/axios';
import { Response } from '../../models/response';
import { ProductsBySKUProps } from '../../models/Admin/AdminProductsManagement';
import httpApi from '../api/httpApi';

const useAdminProductManagement = () => {
    const ADMIN_BC_PRODUCTS_BY_SKU = 'api/v1/admin/bc-products-by-sku';
    const ADMIN_BC_ALL_PRODUCTS = 'api/v1/admin/bc-all-products';
    const ADMIN_BC_STOCK = 'api/v1/admin/bc-stock-locations';
    const ADMIN_BC_PRICE_LIST = 'api/v1/admin/bc-price-lists';
    const ADMIN_BC_METAFIELDS = 'api/v1/admin/bc-metafields';

    const getProductsBySKUFromBC = (data: ProductsBySKUProps) => {
        return httpApi
            .post<any>(ADMIN_BC_PRODUCTS_BY_SKU, data)
            .then((resp) => {
                return resp.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    const getAllProductsFromBC = () => {
        return httpApi
            .get<any>(ADMIN_BC_ALL_PRODUCTS)
            .then((resp) => {
                return resp.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    const getBCStock = () => {
        return httpApi
            .get<any>(ADMIN_BC_STOCK)
            .then((resp) => {
                return resp.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    const getBCPriceList = () => {
        return httpApi
            .get<any>(ADMIN_BC_PRICE_LIST)
            .then((resp) => {
                return resp.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    const setMetafields = () => {
        return httpApi
            .get<any>(ADMIN_BC_METAFIELDS)
            .then((resp) => {
                return resp.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    return {
        getProductsBySKUFromBC,
        getAllProductsFromBC,
        getBCStock,
        getBCPriceList,
        setMetafields,
    };
};

export default useAdminProductManagement;
